import { classNames, Component, h, OmiProps, tag } from "omi";

import { tailwind } from "@/tailwind";

type Props = {
  size: "xs" | "sm" | "md" | "lg";
  padding: "none" | "lg";
  color: "brand" | "white";
};
@tag("nw-loading-spinner")
export class NWLoadingSpinner extends Component<Props> {
  static css = [tailwind];

  static propTypes = {
    size: String,
    padding: String,
    color: String,
  };

  static defaultProps: Props = {
    size: "md",
    padding: "lg",
    color: "brand",
  };

  render({ color = "brand", ...props }: OmiProps<Props>) {
    return (
      <div class={classNames("flex items-center justify-center", { "py-16": props.padding === "lg" })}>
        <svg
          class={classNames(
            "animate-spin -ml-1",
            {
              "w-12 h-12": props.size === "lg",
              "w-8 h-8": props.size === "md",
              "w-6 h-6": props.size === "sm",
              "w-5 h-5": props.size === "xs",
            },
            {
              "text-white": color === "white",
              "text-leather": color === "brand",
            },
          )}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      </div>
    );
  }
}
